module.exports = __webpack_public_path__ + "static/media/ImageOne.a19b3179.jpg";